import { usePermissions } from "react-admin";

const useRequiredScope = (scope: number) => {
  const { loaded, loading, permissions } = usePermissions();
  return !loading && loaded && +permissions?.scope >= scope;
}

export default useRequiredScope;